/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  AhWatchRequest,
  ApiEnvelopeAhListingsResponse,
  ApiEnvelopeAhWatchDeleteResponse,
  ApiEnvelopeAhWatchDto,
  ApiEnvelopeAhWatchListResponse,
  ApiEnvelopeItemStackDto,
  ApiEnvelopeSellbotWizardDiffResponseDto,
  ItemMatchRuleRequest,
  SellbotRulePreviewRequest,
  SellbotWizardRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type ahWatchListResponse200 = {
  data: ApiEnvelopeAhWatchListResponse
  status: 200
}

export type ahWatchListResponseSuccess = (ahWatchListResponse200) & {
  headers: Headers;
};
;

export type ahWatchListResponse = (ahWatchListResponseSuccess)

export const getAhWatchListUrl = () => {




  return `/api/ah/watches`
}

export const useAhWatchListHook = (): ( options?: RequestInit) => Promise<ahWatchListResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getAhWatchListUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type ahWatchCreateResponse200 = {
  data: ApiEnvelopeAhWatchDto
  status: 200
}

export type ahWatchCreateResponseSuccess = (ahWatchCreateResponse200) & {
  headers: Headers;
};
;

export type ahWatchCreateResponse = (ahWatchCreateResponseSuccess)

export const getAhWatchCreateUrl = () => {




  return `/api/ah/watches`
}

export const useAhWatchCreateHook = (): (ahWatchRequest?: AhWatchRequest, options?: RequestInit) => Promise<ahWatchCreateResponse> => {

      const customFetcher = useSfetchMutator();
      return (ahWatchRequest?: AhWatchRequest, options?: RequestInit) => {

        return customFetcher(getAhWatchCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ahWatchRequest)
  }
);
      }
  }


export type ahWatchGetResponse200 = {
  data: ApiEnvelopeAhWatchDto
  status: 200
}

export type ahWatchGetResponseSuccess = (ahWatchGetResponse200) & {
  headers: Headers;
};
;

export type ahWatchGetResponse = (ahWatchGetResponseSuccess)

export const getAhWatchGetUrl = (id: string,) => {




  return `/api/ah/watches/${id}`
}

export const useAhWatchGetHook = (): (id: string, options?: RequestInit) => Promise<ahWatchGetResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getAhWatchGetUrl(id),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type ahWatchUpdateResponse200 = {
  data: ApiEnvelopeAhWatchDto
  status: 200
}

export type ahWatchUpdateResponseSuccess = (ahWatchUpdateResponse200) & {
  headers: Headers;
};
;

export type ahWatchUpdateResponse = (ahWatchUpdateResponseSuccess)

export const getAhWatchUpdateUrl = (id: string,) => {




  return `/api/ah/watches/${id}`
}

export const useAhWatchUpdateHook = (): (id: string,
    ahWatchRequest?: AhWatchRequest, options?: RequestInit) => Promise<ahWatchUpdateResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    ahWatchRequest?: AhWatchRequest, options?: RequestInit) => {

        return customFetcher(getAhWatchUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ahWatchRequest)
  }
);
      }
  }


export type ahWatchDeleteResponse200 = {
  data: ApiEnvelopeAhWatchDeleteResponse
  status: 200
}

export type ahWatchDeleteResponseSuccess = (ahWatchDeleteResponse200) & {
  headers: Headers;
};
;

export type ahWatchDeleteResponse = (ahWatchDeleteResponseSuccess)

export const getAhWatchDeleteUrl = (id: string,) => {




  return `/api/ah/watches/${id}`
}

export const useAhWatchDeleteHook = (): (id: string, options?: RequestInit) => Promise<ahWatchDeleteResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getAhWatchDeleteUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type ahWatchCreateRuleResponse200 = {
  data: ApiEnvelopeAhWatchDto
  status: 200
}

export type ahWatchCreateRuleResponseSuccess = (ahWatchCreateRuleResponse200) & {
  headers: Headers;
};
;

export type ahWatchCreateRuleResponse = (ahWatchCreateRuleResponseSuccess)

export const getAhWatchCreateRuleUrl = (id: string,) => {




  return `/api/ah/watches/${id}/rules`
}

export const useAhWatchCreateRuleHook = (): (id: string,
    itemMatchRuleRequest?: ItemMatchRuleRequest, options?: RequestInit) => Promise<ahWatchCreateRuleResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    itemMatchRuleRequest?: ItemMatchRuleRequest, options?: RequestInit) => {

        return customFetcher(getAhWatchCreateRuleUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(itemMatchRuleRequest)
  }
);
      }
  }


export type ahWatchUpdateRuleResponse200 = {
  data: ApiEnvelopeAhWatchDto
  status: 200
}

export type ahWatchUpdateRuleResponseSuccess = (ahWatchUpdateRuleResponse200) & {
  headers: Headers;
};
;

export type ahWatchUpdateRuleResponse = (ahWatchUpdateRuleResponseSuccess)

export const getAhWatchUpdateRuleUrl = (id: string,
    ruleId: string,) => {




  return `/api/ah/watches/${id}/rules/${ruleId}`
}

export const useAhWatchUpdateRuleHook = (): (id: string,
    ruleId: string,
    itemMatchRuleRequest?: ItemMatchRuleRequest, options?: RequestInit) => Promise<ahWatchUpdateRuleResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    ruleId: string,
    itemMatchRuleRequest?: ItemMatchRuleRequest, options?: RequestInit) => {

        return customFetcher(getAhWatchUpdateRuleUrl(id,ruleId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(itemMatchRuleRequest)
  }
);
      }
  }


export type ahWatchDeleteRuleResponse200 = {
  data: ApiEnvelopeAhWatchDto
  status: 200
}

export type ahWatchDeleteRuleResponseSuccess = (ahWatchDeleteRuleResponse200) & {
  headers: Headers;
};
;

export type ahWatchDeleteRuleResponse = (ahWatchDeleteRuleResponseSuccess)

export const getAhWatchDeleteRuleUrl = (id: string,
    ruleId: string,) => {




  return `/api/ah/watches/${id}/rules/${ruleId}`
}

export const useAhWatchDeleteRuleHook = (): (id: string,
    ruleId: string, options?: RequestInit) => Promise<ahWatchDeleteRuleResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    ruleId: string, options?: RequestInit) => {

        return customFetcher(getAhWatchDeleteRuleUrl(id,ruleId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type ahWatchRulePreviewResponse200 = {
  data: ApiEnvelopeItemStackDto
  status: 200
}

export type ahWatchRulePreviewResponseSuccess = (ahWatchRulePreviewResponse200) & {
  headers: Headers;
};
;

export type ahWatchRulePreviewResponse = (ahWatchRulePreviewResponseSuccess)

export const getAhWatchRulePreviewUrl = () => {




  return `/api/ah/watches/rule-preview`
}

export const useAhWatchRulePreviewHook = (): (sellbotRulePreviewRequest?: SellbotRulePreviewRequest, options?: RequestInit) => Promise<ahWatchRulePreviewResponse> => {

      const customFetcher = useSfetchMutator();
      return (sellbotRulePreviewRequest?: SellbotRulePreviewRequest, options?: RequestInit) => {

        return customFetcher(getAhWatchRulePreviewUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sellbotRulePreviewRequest)
  }
);
      }
  }


export type ahWatchWizardDiffResponse200 = {
  data: ApiEnvelopeSellbotWizardDiffResponseDto
  status: 200
}

export type ahWatchWizardDiffResponseSuccess = (ahWatchWizardDiffResponse200) & {
  headers: Headers;
};
;

export type ahWatchWizardDiffResponse = (ahWatchWizardDiffResponseSuccess)

export const getAhWatchWizardDiffUrl = () => {




  return `/api/ah/watches/rule-wizard-diff`
}

export const useAhWatchWizardDiffHook = (): (sellbotWizardRequest?: SellbotWizardRequest, options?: RequestInit) => Promise<ahWatchWizardDiffResponse> => {

      const customFetcher = useSfetchMutator();
      return (sellbotWizardRequest?: SellbotWizardRequest, options?: RequestInit) => {

        return customFetcher(getAhWatchWizardDiffUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sellbotWizardRequest)
  }
);
      }
  }


export type ahWatchApplyRulesResponse200 = {
  data: ApiEnvelopeAhWatchDto
  status: 200
}

export type ahWatchApplyRulesResponse400 = {
  data: ApiEnvelopeAhWatchDto
  status: 400
}

export type ahWatchApplyRulesResponseSuccess = (ahWatchApplyRulesResponse200) & {
  headers: Headers;
};
export type ahWatchApplyRulesResponseError = (ahWatchApplyRulesResponse400) & {
  headers: Headers;
};

export type ahWatchApplyRulesResponse = (ahWatchApplyRulesResponseSuccess | ahWatchApplyRulesResponseError)

export const getAhWatchApplyRulesUrl = (id: string,) => {




  return `/api/ah/watches/${id}/rules/apply`
}

export const useAhWatchApplyRulesHook = (): (id: string,
    sellbotWizardRequest?: SellbotWizardRequest, options?: RequestInit) => Promise<ahWatchApplyRulesResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    sellbotWizardRequest?: SellbotWizardRequest, options?: RequestInit) => {

        return customFetcher(getAhWatchApplyRulesUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sellbotWizardRequest)
  }
);
      }
  }


export type ahWatchMatchesResponse200 = {
  data: ApiEnvelopeAhListingsResponse
  status: 200
}

export type ahWatchMatchesResponseSuccess = (ahWatchMatchesResponse200) & {
  headers: Headers;
};
;

export type ahWatchMatchesResponse = (ahWatchMatchesResponseSuccess)

export const getAhWatchMatchesUrl = (id: string,) => {




  return `/api/ah/watches/${id}/matches`
}

export const useAhWatchMatchesHook = (): (id: string, options?: RequestInit) => Promise<ahWatchMatchesResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getAhWatchMatchesUrl(id),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


